const currencyFormat = (value, locale = 'tr-TR', opt) => {
  let defaultOpt = {
    style: 'currency',
    currency: 'TRY',
  };

  if (opt && typeof opt === 'object') {
    Object.keys(opt).forEach((v) => {
      defaultOpt[v] = opt[v];
    });
  }

  let ntl = new Intl.NumberFormat(locale, defaultOpt);

  return ntl.format(value);
};

export default currencyFormat;
